import { useMemo } from 'react';

import { SlideOut } from '@interstate/components/SlideOut';

import VehicleSearchFilters from './VehicleSearchFilters';
import { useVehicleSearchFiltersContext } from './VehicleSearchFiltersContext';
import type { OptionButton, OptionButtonTuple, PrimaryButton } from '@interstate/components/ActionButtons';

const VehicleSearchFiltersSlideOut = () => {
    const { appliedFilters, filterSlideOutOpen, setFilterSlideOutOpen, clearAllFilters } = useVehicleSearchFiltersContext();

    const showClearAll = useMemo(() => appliedFilters.length > 0, [appliedFilters]);

    const primaryButton: PrimaryButton = {
        buttonStyle: 'primary',
        action: () => setFilterSlideOutOpen(false),
        label: 'Apply'
    };

    const optionButtons = useMemo(() => {
        if (!showClearAll) {
            return [] as OptionButtonTuple;
        }

        return {
            buttonStyle: 'secondary',
            action: clearAllFilters,
            label: 'Clear All'
        } as OptionButton;
    }, [showClearAll]);

    return (
        <SlideOut
            show={filterSlideOutOpen}
            header="Filters"
            data-testid="vehicle-search-filters-slide-out"
            position="left"
            panelWidth="400px"
            onHide={() => setFilterSlideOutOpen(false)}
            footer={{
                primary: primaryButton,
                options: optionButtons
            }}
        >
            <VehicleSearchFilters />
        </SlideOut>
    );
};

export default VehicleSearchFiltersSlideOut;
